export const SHOP_APOTHEKE_SELLER_ID = 'shop-apotheke'
